import styled from "styled-components";

export const RequestWrapper = styled.div``